import { generateDivNoRem } from '../generators/math-gen3-up/div-no-rem';
import { runGenericMathKpLesson } from './_runner';
import type { LearnDoneCallback } from '../app';

/**
 * KP `math.div.no-remainder` (N-3-5):
 * 三下「整除（除以一位數直式）」— guarantee exact division (no remainder).
 * Uses generateDivNoRem whose quotients are computed as divisor × q, so every
 * answer is a clean integer.
 */
export function runMathDivNoRemainderLesson(container: HTMLElement, onDone: LearnDoneCallback): void {
  runGenericMathKpLesson(container, {
    subject: 'math',
    kpId: 'math.div.no-remainder',
    generator: generateDivNoRem,
  }, onDone);
}
